'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

exports.default = {
  localeUtils: _react.PropTypes.shape({
    formatMonthTitle: _react.PropTypes.func,
    formatWeekdayShort: _react.PropTypes.func,
    formatWeekdayLong: _react.PropTypes.func,
    getFirstDayOfWeek: _react.PropTypes.func
  })
};
//# sourceMappingURL=PropTypes.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-day-picker/lib/PropTypes.js
// module id = 191
// module chunks = 0